import {
  useEffect, useRef, useState,
} from 'react';
import { createPortal } from 'react-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPaperPlane, faRefresh } from '@fortawesome/free-solid-svg-icons';
import moment from 'moment';
import { useSelector } from 'react-redux';
import DOMPurify from 'dompurify';
import { marked } from 'marked';
import { GeneralChatStyled } from '../GeneralChat/GeneralChat.styles';
import { getQuotationTypeName } from '../../../constants';

export const getProductName = (id) => {
  if (id === 1) return 'Auto';
  if (id === 2) return 'Moto';
  if (id === 3) return 'Autocarro';
  if (id === 4) return 'Profession';
  if (id === 8) return 'Travel';
  if (id === 9) return 'Tutela Legale';
  if (id === 10) return 'Commercial';
  if (id === 11) return 'Casa';
  if (id === 12) return 'Salute';
  if (id === 13) return 'Ancillari Auto';
  if (id === 15) return 'RC Professionale Sanita';
  if (id === 1000) return 'Pubblico Impiego';
  if (id === 1001) return 'Malattia';
  if (id === 1002) return 'Infortunio';
  if (id === 1003) return 'Condominio';
  if (id === 1004) return 'Rc Famiglia';

  return '';
};

function MiniChat({
  openChat,
  setOpenChat,
  company_id,
  product_id,
  quote_type,
  company_name,
  extraText = null,
  professionId = null,
  sub_product = null,
}) {
  const [messages, setMessages] = useState([]);
  const [message, setMessage] = useState('');
  const bottomRef = useRef(null);
  const textareaRef = useRef(null);
  const [threadId, setThreadId] = useState(null);
  // const [isTyping, setIsTyping] = useState(false);
  const { quoteTypes } = useSelector((store) => store.utilities.quoteTypes);
  const [status, setStatus] = useState('idle'); // ? "idle" | "streaming" | "done" | "error" | 'reasoning';
  const [streaming, setStreaming] = useState('');

  const resetConversation = () => {
    setThreadId(null);
    setStatus('idle');
    setStreaming('');
    setMessages(() => {
      const productName = getProductName(product_id);
      const introMessage = {
        id: 'intro-message',
        from: 'system',
        message: `Puoi chiedermi di ${getQuotationTypeName(quote_type, quoteTypes)
          ? getQuotationTypeName(quote_type, quoteTypes).replace('_', ' ')
          : 'questo prodotto'
        } ${product_id && company_id
          ? `${productName} dalla compagnia ${company_name}`
          : ''
        }`,
        created_at: new Date().toISOString(),
      };
      return [introMessage];
    });
    setMessage('');
  };

  // const sendMessage = async (text) => {
  //   if (!text.trim()) return;

  //   setMessages((prev) => prev.filter((msg) => msg.id !== 'intro-message'));

  //   const newUserMessage = {
  //     id: Date.now().toString(),
  //     from: 'user',
  //     message: text,
  //     created_at: new Date().toISOString(),
  //   };
  //   setMessages((prev) => [...prev, newUserMessage]);
  //   setMessage('');

  //   setIsTyping(true);

  //   try {
  //     const response = await chatAxe.post('/chat/message/assistant/send', {
  //       thread_id: threadId,
  //       question: text,
  //       company_id,
  //       product_id,
  //       sub_product,
  //       quote_type:
  //         product_id == 13
  //           && getQuotationTypeName(quote_type, quoteTypes) === 'Responsabilita Civile'
  //           ? 'Furto e Incendio'
  //           : getQuotationTypeName(quote_type, quoteTypes),
  //       product_name: getProductName(product_id),
  //       company_name,
  //       extraText,
  //       profession_id: professionId,
  //     });

  //     if (response.status === 200) {
  //       const last_answer = response.data.data.response;
  //       setThreadId(response.data.data.thread_id);
  //       const newBotMessage = {
  //         id: `${Date.now().toString()}-system`,
  //         from: 'system',
  //         message: last_answer,
  //         created_at: new Date().toISOString(),
  //       };
  //       setMessages((prev) => [...prev, newBotMessage]);
  //     }
  //   } catch (error) {
  //     const errorMessage = {
  //       id: `${Date.now().toString()}-error`,
  //       from: 'system',
  //       message: 'Something went wrong. Please try again.',
  //       created_at: new Date().toISOString(),
  //     };
  //     setMessages((prev) => [...prev, errorMessage]);
  //   } finally {
  //     setIsTyping(false);
  //   }
  // };

  const sendMessageStream = async (text) => {
    if (!text.trim()) return;

    setMessages((prev) => prev.filter((msg) => msg.id !== 'intro-message'));

    const newUserMessage = {
      id: Date.now().toString(),
      from: 'user',
      message: text,
      created_at: new Date().toISOString(),
    };
    setMessages((prev) => [...prev, newUserMessage]);
    setMessage('');

    // setIsTyping(true);

    const url = `${process.env.REACT_APP_CHAT_SERVICE_API_URL}/chat/message/assistant/send`;
    const token = localStorage.getItem('jwtToken');
    const quoteType = product_id == 13
      && getQuotationTypeName(quote_type, quoteTypes) === 'Responsabilita Civile'
      ? 'Furto e Incendio'
      : getQuotationTypeName(quote_type, quoteTypes);

    const eventSource = new EventSource(`${url}?thread_id=${threadId ?? ''}&question=${encodeURIComponent(text)}&company_id=${company_id}&product_id=${product_id}&sub_product=${sub_product}&quote_type=${encodeURIComponent(quoteType)}&product_name=${encodeURIComponent(getProductName(product_id))}&company_name=${encodeURIComponent(company_name)}&extraText=${encodeURIComponent(extraText)}&profession_id=${professionId}&token=${token}`);

    let fullText = '';
    setStreaming('');
    setStatus('reasoning');
    let buffer = '';
    let rafId = null;
    let streaming = true;

    const flush = () => {
      if (!streaming) return;

      if (buffer.length > 0) {
        // limit chars per frame (tweak this)
        const chunk = buffer.slice(0, 3);
        buffer = buffer.slice(3);

        fullText += chunk;
        setStreaming(fullText);
      }

      rafId = requestAnimationFrame(flush);
    };

    const startFlush = () => {
      if (rafId === null) {
        rafId = requestAnimationFrame(flush);
      }
    };

    const stopFlush = () => {
      streaming = false;
      if (rafId !== null) {
        cancelAnimationFrame(rafId);
        rafId = null;
      }
    };

    eventSource.onmessage = (event) => {
      const payload = JSON.parse(event.data);

      switch (payload.type) {
        case 'start':
          startFlush();
          break;
        case 'text_delta':
          setStatus('streaming');
          buffer += payload.text; // ⚡ buffer only
          break;
        case 'done':
          stopFlush();
          fullText += buffer;
          buffer = '';

          setStreaming(fullText);
          setStatus('done');
          // ✅ append final message to chat
          setThreadId(payload.thread_id);
          setMessages((prev) => [...prev, {
            id: `${Date.now().toString()}-system`,
            from: 'system',
            message: fullText,
            created_at: new Date().toISOString(),
          }]);
          eventSource.close();
          // ✅ smooth transition: clear streaming AFTER render
          setTimeout(() => {
            setStreaming('');
          }, 0);
          break;
        case 'error':
          stopFlush();
          setStatus('error');
          setStreaming('Un errore è accaduto durante la generazione della risposta. Riprova.');
          eventSource.close();
          break;

        default:
          stopFlush();
          setStatus('error');
          setStreaming('Un errore è accaduto durante la generazione della risposta. Riprova.');
      }
    };

    eventSource.onerror = () => {
      stopFlush();
      setStatus('error');
      setStreaming('Un errore è accaduto durante la generazione della risposta. Riprova.');
      eventSource.close();
    };
  };

  const scrollToBottom = () => {
    bottomRef.current?.scrollIntoView({ behavior: 'smooth' });
  };

  useEffect(() => {
    scrollToBottom();
  }, [messages]);

  const handleKeyPress = (e) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      sendMessageStream(message);
    }
  };

  const getText = () => {
    const productName = getProductName(product_id);
    const quoteTypeName = product_id == 13
      && getQuotationTypeName(quote_type, quoteTypes) === 'Responsabilita Civile'
      ? 'Furto e Incendio'
      : getQuotationTypeName(quote_type, quoteTypes);
    let generatedMessage = `Puoi chiedermi di ${getQuotationTypeName(quote_type, quoteTypes)
      ? quoteTypeName.replace('_', ' ')
      : "questo prodotto'"
    } `;

    if (product_id && company_id) {
      generatedMessage += `${productName} dalla compagnia ${company_name}`;
    }

    const initialSystemMessage = {
      id: 'intro-message',
      from: 'system',
      message: generatedMessage,
      created_at: new Date().toISOString(),
    };

    setMessages((prev) => (prev.length === 0 ? [initialSystemMessage] : prev));
  };

  useEffect(() => {
    getText();
  }, [product_id, quote_type, company_id]);

  useEffect(() => {
    if (openChat && textareaRef.current) {
      const focusTextarea = () => {
        if (textareaRef.current) {
          textareaRef.current.blur();

          setTimeout(() => {
            if (textareaRef.current) {
              textareaRef.current.focus();
              textareaRef.current.click();
              textareaRef.current.select();

              setTimeout(() => {
                if (textareaRef.current) {
                  textareaRef.current.focus();
                }
              }, 50);
            }
          }, 100);
        }
      };

      requestAnimationFrame(() => {
        requestAnimationFrame(focusTextarea);
      });
    }
  }, [openChat]);

  useEffect(() => {
    const handleEscKey = (event) => {
      if (event.key === 'Escape' && openChat) {
        if (event.target.tagName === 'TEXTAREA') {
          return;
        }
        event.preventDefault();
        event.stopPropagation();
        setOpenChat(false);
      }
    };

    if (openChat) {
      document.addEventListener('keydown', handleEscKey, true);
      return () => {
        document.removeEventListener('keydown', handleEscKey, true);
      };
    }

    return undefined;
  }, [openChat, setOpenChat]);

  return (
    <>
      {openChat === true && createPortal(
        <GeneralChatStyled>
          <div className="chat-modal">
            <div className="backdrop" onClick={() => setOpenChat(false)} />
            <div
              className="chat-container"
              onClick={(e) => {
                if (e.target === e.currentTarget) {
                  textareaRef.current?.focus();
                }
              }}
            >
              <div className="chat-title d-flex justify-content-between align-items-center">
                <div className="chat-title-info fw-bold">
                  Informazioni
                  {' '}
                  {product_id == 13
                    && getQuotationTypeName(quote_type, quoteTypes) === 'Responsabilita Civile'
                    ? 'Furto e Incendio'
                    : getQuotationTypeName(quote_type, quoteTypes)}
                  {' '}
                  {company_name}
                </div>
                <div className="chat-title-actions d-flex align-items-center gap-2">
                  {messages.length !== 0 && (
                    <button
                      className="btn btn-sm"
                      onClick={() => resetConversation()}
                      title="Reset conversation"
                      style={{ color: 'white', fontSize: '1.0rem' }}
                    >
                      <FontAwesomeIcon icon={faRefresh} />
                    </button>
                  )}
                  <button
                    type="button"
                    className="btn btn-sm"
                    aria-label="Close"
                    onClick={() => setOpenChat(false)}
                    title="Close chat"
                    style={{ color: 'white', fontSize: '1.2rem' }}
                  >
                    ✖
                  </button>
                </div>
              </div>
              <div className="chat-content">
                {messages.map((m) => (
                  <div
                    className={`chat-message chat-message-${m.from}`}
                    key={m.id}
                  >
                    <div className="chat-message-time">
                      {moment(m.created_at).fromNow()}
                    </div>
                    <div
                      className="chat-message-message"
                      dangerouslySetInnerHTML={{
                        __html: m?.message.replaceAll('\n', '<br />'),
                      }}
                    />
                  </div>
                ))}

                {status === 'reasoning' && (
                  <div className="d-flex align-items-center justify-content-start gap-2">
                    <div className="spinner-border spinner-border-sm" role="status">
                      <span className="visually-hidden">
                        Loading...
                      </span>
                    </div>
                    <p className="m-0">
                      <small>
                        Annalizzando i documenti relativi alla tua richiesta, attendi qualche istante...
                      </small>
                    </p>
                  </div>
                )}

                {streaming !== '' && (
                  <div
                    className="chat-message chat-message-system"
                  >
                    <div className="chat-message-time">
                      {moment().fromNow()}
                    </div>
                    <div
                      className="chat-message-message"
                      dangerouslySetInnerHTML={{
                        __html: DOMPurify.sanitize(marked.parse(streaming)),
                      }}
                    />
                  </div>
                )}

                {/* {isTyping && (
                  <div className="chat-message chat-message-system">
                    <div className="chat-message-message d-flex align-items-center justify-content-start">
                      <div
                        className="spinner-border spinner-border-sm"
                        role="status"
                      >
                        <span className="visually-hidden">Loading...</span>
                      </div>
                      <div className="ms-2">Generando la risposta...</div>
                    </div>
                  </div>
                )} */}

                <div ref={bottomRef} className="bottom-ref" />
              </div>
              <div className="chat-message-sender">
                <textarea
                  ref={textareaRef}
                  value={message}
                  onChange={(e) => setMessage(e.target.value)}
                  placeholder="Scrivi la tua domanda..."
                  maxLength={500}
                  onKeyDown={handleKeyPress}
                  onClick={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    if (textareaRef.current) {
                      textareaRef.current.focus();
                    }
                  }}
                  onFocus={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                  }}
                  style={{
                    pointerEvents: 'auto',
                    userSelect: 'text',
                    cursor: 'text',
                  }}
                />
                <div
                  className="chat-message-send-button"
                  onClick={() => sendMessageStream(message)}
                >
                  <FontAwesomeIcon icon={faPaperPlane} />
                </div>
              </div>
            </div>
          </div>
        </GeneralChatStyled>,
        document.body,
      )}
    </>
  );
}

export const Chat = MiniChat;
